import classNames from 'classnames';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import trashIcon from '../../icons/non-prefilled/16x16/trash.svg';
import ToolbarButton, {
  ToolbarButtonGroup,
} from '../controls/toolbar/buttons/ToolbarButton';
import formatBlotWithoutScrolling from '../controls/toolbar/formatBlotWithoutScrolling';
import { useQuill } from '../QuillContext';
import * as styles from './TableToolbar.module.scss';
import type { Selection } from './useTableSelection';
import { getRowColumnItems, SelectionType } from './useTableSelection';
import ToolbarSpanButtonGroup from '../controls/toolbar/buttons/ToolbarSpanButtonGroup';

interface TableToolbarProps {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  blot: any;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  span: any;
  tableContainer: HTMLElement;
  selection: Selection | null;
  onDelete: () => void;
}

const TableToolbar = ({
  blot,
  span,
  tableContainer,
  selection,
  onDelete,
}: TableToolbarProps) => {
  const { quill } = useQuill();
  const [rect, setRect] = useState<{ top: number; left: number } | null>(null);

  useEffect(() => {
    const [items, isRow] = getRowColumnItems(selection);
    const element =
      items &&
      tableContainer.querySelector(
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        `[data-table-${isRow ? 'row' : 'column'}="${_.min(items)}"]`,
      );
    if (element) {
      const elementRect = element.getBoundingClientRect();
      const tableRect = tableContainer.getBoundingClientRect();
      const left = elementRect.left - tableRect.left;
      const top = elementRect.top - tableRect.top;
      setRect(isRow ? { top, left } : { top, left: left + elementRect.width });
    } else if (selection?.type === SelectionType.Table) {
      setRect({ top: -parseInt(styles.insertButtonSize, 10), left: 0 });
    } else {
      setRect(null);
    }
  }, [selection, tableContainer]);

  const format = (attributes: Record<string, unknown>) => {
    if (!quill) return;
    formatBlotWithoutScrolling({ quill, blot, attributes });
  };

  if (!rect) return null;
  if (
    selection?.type !== SelectionType.Table &&
    selection?.type !== SelectionType.Column &&
    selection?.type !== SelectionType.Row
  ) {
    return null;
  }

  return (
    <div
      data-no-print
      className={classNames(styles.container, {
        [styles.table]: selection?.type === SelectionType.Table,
        [styles.column]: selection?.type === SelectionType.Column,
        [styles.row]: selection?.type === SelectionType.Row,
      })}
      role="toolbar"
      style={rect}
    >
      {selection?.type === SelectionType.Table && (
        <ToolbarSpanButtonGroup
          span={span}
          onSpanChange={(newSpan) => format({ span: newSpan })}
        />
      )}
      <ToolbarButtonGroup>
        <ToolbarButton
          onClick={onDelete}
          icon={trashIcon}
          aria-label="Delete table"
          tooltip="Delete"
        />
      </ToolbarButtonGroup>
    </div>
  );
};

export default TableToolbar;
